import React, { useCallback, useEffect, useState } from "react";
import { dashboardEditorAPI } from "../../api/dashboard";
import { Link } from "react-router-dom";

function DashboardEditor() {
  const [data, setData] = useState({});

  const editordata = useCallback(() => {
    dashboardEditorAPI()
      .then((res) => {
        setData(res);
      })
      .catch((err) => console.log(err));
  }, [setData]);

  useEffect(() => {
    editordata();
  }, [editordata]);

  return (
    <div className="col-xl-12">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Editors</h5>
          <hr />
          <div className="row separate-row">
            <div className="col-sm-6">
              <div className="job-icon pb-4">
                {/* <Link to="/user_list"> */}
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{data?.total_editors}</h2>
                    <i className={`fa-solid ms-3 fa-arrows-left-right`}></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Total Editor</span>
                {/* </Link> */}
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pb-4 pt-4 pt-sm-0 d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{data?.active_editors}</h2>
                    <i className={`fa-solid ms-3 fa-arrows-left-right`}></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Active Editor</span>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-4 pb-sm-0 pb-4 pe-3 d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{data?.inactive_editors}</h2>
                    <i className={`fa-solid ms-3 fa-arrows-left-right`}></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Inactive Editor</span>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{data?.today_editors}</h2>
                    <i
                      className={`fa-solid ms-3 ${data?.today_editors_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Today's Editor</span>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-4  d-flex justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{data?.jobs_by_editors}</h2>
                    <i
                      className={`fa-solid ms-3 ${data?.jobs_by_editors_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Editor Jobs</span>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-4  d-flex justify-content-between"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardEditor;
